module.exports = __webpack_public_path__ + "static/media/cx.fdd71998.jpeg";